import {Button, Form, Input, Modal, Switch} from 'antd';
import React, { useEffect, useState } from 'react';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import bannerService from '../../services/banner-service';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import UploadImage from '../../components/upload/image';
import EditableTagGroup from '../../components/input/editable-tag-group';
import { fileTYPE_IMG, groupType } from '../../constants/app-constants';
import fileUtils from '../../utils/file-utils';

const defaultValue = {
    bannerImage: null,
    isOpenNewTab: false,
    keywordList: [],
};

const AddEditBannerDialog = ({ isShow, onCancel, onSaveComplete, editData }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [bannerImage, setBannerImage] = useState(defaultValue.bannerImage);
    const [keywordList, setKeywordList] = useState(defaultValue.keywordList);

    useEffect(() => {
        if (!isShow) {
            setBannerImage(defaultValue.bannerImage);
            setKeywordList(defaultValue.keywordList);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                title: editData.title,
                url: editData.url,
                status: editData.status,
                totalView: editData.totalView,
                enableNewTab: editData.enableNewTab
            });

            setBannerImage(editData.attachImage);
            setKeywordList(editData.keywordList ? editData.keywordList : defaultValue.keywordList);
         
        }
    }, [isShow, editData]);

    const onSave = async () => {
        try {
            const values = await form.validateFields();
            try {

                dispatch(appLoaderAction.enable());
                
                if (!editData) {
                    let bean = {
                        title: values.title,
                        keywordList: keywordList,
                        url: values.url,
                        attachImage: bannerImage,
                        enableNewTab: values.enableNewTab,
                        status: values.status,
                        totalView: 0
                    };

                    await bannerService.add({bean: bean});
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    bean.title = values.title;
                    bean.keywordList = keywordList;
                    bean.url = values.url;
                    bean.attachImage = bannerImage;
                    bean.enableNewTab = values.enableNewTab;
                    bean.status = values.status;
                    bean.totalView = editData.totalView;
                    await bannerService.edit({bean: bean});
                }

                dispatch(appLoaderAction.disale());
                notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');
                onSaveComplete();
            } catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
            }
        } catch (errorInfo) {
            notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
        }
    };

    const onUploadTemp = ({ file }) => {
        if (file.status === 'done') {
            const { bean } = file.response;
            setBannerImage(bean);
        }
	};

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        editData ? 'แก้ไขแบนเนอร์' : 'เพิ่มแบนเนอร์'
                    }
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave}>
                            <Icon.Save className="me-2" size={17} />บันทึก
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            ยกเลิก
                        </Button>,
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_banner"
                        preserve={false}
                        form={form}
                        initialValues={{status: true, enableNewTab: true}}
                        validateMessages={{
                            required: 'โปรดระบุ',
                        }}>

                        <Form.Item
                            label="ชื่อแบนเนอร์"
                            name="title"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="รูปภาพ"
                            valuePropName="fileList"
                            name="imageHeader"
                            rules={[
                                {
                                    required: bannerImage ? false : true,
                                },
                            ]}>
                            <UploadImage  
                                listType="picture-card"
                                accept={fileTYPE_IMG}
                                showUploadList={false}
                                onChange={onUploadTemp}
                                className={bannerImage ? 'view-upload' : null}>
                                  {bannerImage ? (
                                        <img
                                            src={
                                                bannerImage.tempFilename
                                                    ? fileUtils.getTempFileRenderUrl(
                                                            bannerImage.tempFilename,
                                                            bannerImage.type
                                                    )
                                                    : fileUtils.getFileRenderUrl(
                                                            groupType.BANNER,
                                                            editData ? editData.bannerId : null,
                                                            bannerImage.originalFilename
                                                    )
                                            }
                                            alt="avatar"
                                            style={{ width: '100%' }}
                                        />
                                    ) : 'อัปโหลดไฟล์'}
                            </UploadImage>
                            <label className="text-danger">* ขนาดรูปภาพที่แนะนำคือ 1920x822 pixels.</label>
                        </Form.Item>

                        <Form.Item label="ลิงค์" name="url">
                            <Input />
                        </Form.Item>

                        <Form.Item label="คีย์เวิร์ด" >
                            <EditableTagGroup onChange={setKeywordList} tags={keywordList} />
                        </Form.Item>

                        <Form.Item label="เปิดแท็บใหม่" name="enableNewTab" valuePropName="checked">
                            <Switch />
                        </Form.Item>

                        <Form.Item label="สถานะ" name="status" valuePropName="checked">
                            <Switch />
                        </Form.Item>

                    </Form>
                </Modal>
            </div>
        </div>
    )
};

export default AddEditBannerDialog;